import { TFunction } from 'i18next';

import { SprueTreatmentSelection } from '../../../../../../../PcfWizard.type';

export const getSprueTreatmentTypeOptions = (
  t: TFunction,
): { label: string; value: SprueTreatmentSelection }[] => {
  return [
    {
      label: t(
        'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.wasteManagementSection.inputs.sprueTreatmentTypeOptions.reusedInSameMachine',
      ),
      value: SprueTreatmentSelection.REUSED_IN_SAME_MACHINE,
    },
    {
      label: t(
        'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.wasteManagementSection.inputs.sprueTreatmentTypeOptions.discarded',
      ),
      value: SprueTreatmentSelection.DISCARDED,
    },
  ];
};
